"use client";

import { Container } from "./container";
import { Button } from "./ui/button";
import { MotionDiv, useInView } from "@/lib/framer";
import { useRef } from "react";
import { Link } from "@inertiajs/react";
import { ArrowRight } from "lucide-react";

export default function CallToAction() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <Container className="py-16">
      <MotionDiv
        ref={ref}
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.5 }}
        className="bg-golden-500 rounded-3xl px-6 py-16 sm:px-12 sm:py-24 lg:flex lg:items-center lg:justify-between lg:gap-x-16 lg:px-16"
      >
        <MotionDiv
          initial={{ opacity: 0, x: -20 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="max-w-2xl text-3xl font-bold text-white sm:text-4xl dark:text-gray-900"
        >
          Ready to ditch your standups and get your first code report?
        </MotionDiv>
        <MotionDiv
          initial={{ opacity: 0, x: 20 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 20 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:shrink-0"
        >
          <Link href="/sign_in">
            <Button size="lg" className="bg-black text-white hover:bg-black/90">
              Connect GitHub & Subscribe <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </MotionDiv>
      </MotionDiv>
    </Container>
  );
}
